<template>
  <v-container grid-list-xl>
    <v-layout wrap>
      <v-flex sm4 xs12 md4 lg4>
        <material-stats-card
          color="green"
          icon="mdi-coin"
          title="Saldo disponível"
          :value="available | formatCurrency"
          small-value="R$"
          sub-icon="mdi-currency-usd"
          sub-text="ATUAL"
        />
      </v-flex>
      <v-flex sm4 xs12 md4 lg4>
        <material-stats-card
          color="blue"
          icon="mdi-clock"
          title="Saldo a receber"
          :value="waiting_funds | formatCurrency"
          small-value="R$"
          sub-icon="mdi-currency-usd"
          sub-text="A RECEBER"
        />
      </v-flex>
      <v-flex sm4 xs12 md4 lg4>
        <material-stats-card
          color="orange"
          icon="mdi-download"
          title="Saques Realizados"
          :value="transferred | formatCurrency"
          small-value="R$"
          sub-icon="mdi-currency-usd"
          sub-text="SAQUES"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { EventBus } from "../../../utils/event-bus";

export default {
  data: () => ({
    balance: 0,
    waiting_funds: 0,
    transferred: 0,
    available: 0,
  }),
  mounted() {
    EventBus.$on("LoadBalance", (balance) => {
      this.loading = true;
      this.waiting_funds = balance.waiting_funds.amount / 100;
      this.transferred = balance.transferred.amount / 100;
      this.available = balance.available.amount / 100;
      this.loading = false;
    });
  },
};
</script>
